import { MapLayerType } from '@/components/map/map-utils/WebMapTileServices';
import { RootState } from '@/state';
import { createSelector } from 'reselect';
// Meta
export const stateErrors = (state: RootState) => state.metaState.errors;
export const stateNotifications = (state: RootState) => state.metaState.notifications;
export const stateLastVisitedNotifications = (state: RootState) =>
    state.metaState.lastVisitedNotifications;
// Map
export const stateMap = (state: RootState) => state.mapState;
export const stateMapLayer = (state: RootState) => state.mapState.mapLayer;
export const stateKartutsnitt = (state: RootState) => state.mapState.kartutsnitt;
export const stateZoom = (state: RootState) => state.mapState.zoom;
export const stateZoomToExtent = (state: RootState) => state.mapState.zoomToExtent;
// Search
export const stateFilterPanelOpen = (state: RootState) =>
    state.searchState.filterPanelOpen;
export const statePlacenames = (state: RootState) => state.searchState.placeNames;
export const stateRecentSearchQueries = (state: RootState) =>
    state.searchState.recentSearchQueries;
export const stateSearchDropdownState = (state: RootState) =>
    state.searchState.searchDropdownState;
export const stateSearchTimestamp = createSelector(
    stateSearchDropdownState,
    i => i.timestamp
);
export const stateSearchPanelOpen = (state: RootState) =>
    state.searchState.searchPanelOpen;
// Omrader
export const stateOmrader = (state: RootState) => state.omraderState;
export const stateLand = (state: RootState) => state.omraderState.land;
export const stateFylker = (state: RootState) => state.omraderState.fylke;
export const stateKommuner = (state: RootState) => state.omraderState.kommune;
export const statePolygon = (state: RootState) => state.omraderState.polygon;
export const stateKontraktsomrader = (state: RootState) =>
    state.omraderState.kontraktsomrade;
export const stateRiksvegruter = (state: RootState) => state.omraderState.riksvegrute;
export const stateVegsystemreferanser = (state: RootState) =>
    state.omraderState.vegsystemreferanse;
// Vegobjekter
export const stateVegobjekter = (state: RootState) => state.vegobjekterState;
export const stateSelectedRoadObjectTypes = (state: RootState) =>
    state.vegobjekterState.vegobjekttypeStates;
export const stateIsCategorizing = (state: RootState) =>
    state.vegobjekterState.categorizing;
// Vegnett
export const stateVegnett = (state: RootState) => state.vegnettState;
export const stateVegnettlenker = (state: RootState) => state.vegnettState.vegnettlenker;
export const stateVegnettVisible = (state: RootState) => state.vegnettState.visible;
export const stateVegnettFilter = (state: RootState) => state.vegnettState.filter;
export const stateVegnettStatistics = (state: RootState) => state.vegnettState.statistics;
export const stateVegnettLoading = (state: RootState) => state.vegnettState.loading;
export const stateVegnettProgress = (state: RootState) => state.vegnettState.progress;
export const stateVegnettDirection = (state: RootState) => state.vegnettState.direction;
// Advanced filter
export const statePossibleAdvancedFilterValuesSearchContext = createSelector(
    [stateMap, stateOmrader, stateVegnett, stateVegobjekter, stateSearchTimestamp],
    (mapState, omraderState, vegnettState, vegobjekterState, timestamp) => ({
        mapState,
        omraderState,
        vegnettState,
        vegobjekterState,
        timestamp,
    })
);
// Valgt
export const stateValgt = (state: RootState) => state.valgtState;
export const stateLinkQueries = (state: RootState) => state.valgtState.linkQueries;
// Overlay
export const stateGeolocationState = (state: RootState) =>
    state.overlayState.geolocationState;
export const statePlacenameMarker = (state: RootState) =>
    state.overlayState.placenameMarker;
export const stateVegsystemreferanseSok = (state: RootState) =>
    state.overlayState.vegsystemreferanseLookup;
export const stateSplash = (state: RootState) => state.splashState;
export const stateLoginWindow = (state: RootState) => state.loginWindowState;
export const stateUser = (state: RootState) => state.userState;
// Config
export const stateConfig = (state: RootState) => state.config;
export const aerialViewActive = createSelector([stateMapLayer], mapLayer => {
    return mapLayer === MapLayerType.FLYFOTO;
});
export const stateMeasurement = (state: RootState) => state.measurementState;
export const measurementActive = createSelector(
    [stateMeasurement],
    measurement => measurement.active
);

export const statePreferences = (state: RootState) => state.preferences;

export const stateIsDrawing = createSelector([measurementActive], measuring => measuring);
